export {
  ProjectsAcademyModal,
  useOpenProjectsAcademy,
} from "./components/projects-academy";
export {
  JobsAcademyModal,
  useOpenJobsAcademy,
} from "./components/jobs-academy";
export {
  TasksAcademyModal,
  useOpenTasksAcademy,
} from "./components/tasks-academy";
export { PROJECTS_ACADEMY_CONTENT } from "./lib/projects";
export { JOBS_ACADEMY_CONTENT } from "./lib/jobs";
export { TASKS_ACADEMY_CONTENT } from "./lib/tasks";
